import AddIcon from '@mui/icons-material/Add';
import { Stack, Typography } from '@mui/material';
import { FC, useCallback } from 'react';
import { useTranslate } from 'react-admin';

interface Props {
  totalRows: number;
  onAddRow: (index: number) => void;
  testId: string;
}

export const B2bInvestorProfileSicavGridAddRowButton: FC<Props> = (props) => {
  const { onAddRow, totalRows, testId } = props;

  const translate = useTranslate();

  const handleAddRow = useCallback(() => {
    onAddRow(totalRows);
  }, [onAddRow, totalRows]);

  return (
    <Typography color="textSecondary">
      {/* oxlint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={handleAddRow} data-testid={testId}>
        <Stack direction="row" gap={1} sx={{ cursor: 'pointer', maxWidth: '150px' }}>
          <AddIcon sx={{ fontSize: 24 }} />
          {translate(
            'resources.bo_common.b2b.investor_profile.create.sicav_grid_configuration.add_row',
          )}
        </Stack>
      </div>
    </Typography>
  );
};
